<template>
  <div>
    <div class="block text-center">
      <el-carousel trigger="click" :height="smallImageHeight" :interval="3500" arrow="always">
        <el-carousel-item class="carousel-div" v-for="item in mainImageList" :key="item.id">
<!--          <img ref="myInput" class="carousel-img" @load='imgOnError' :src="item.imageUrl" />-->
          <el-image
              ref="myInput"
              class="carousel-img"
              @load='imgOnError'
              :src="item.imageUrl"
              :fit="'cover'"
              ></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
  <!--  <HomeIndex msg="Welcome to Your Vue.js App"/>-->
  <div class="home-index-product">
    <p class="index-title">{{locale[language.code].home.module.name1}}</p>
    <el-row>
      <el-col v-for="item in productTypeList" :key="item.id" :xs="12" :sm="12" :md="12" :lg="6" :xl="6">
        <router-link :to="'/productgroup/'+item.id" :underline="false">
          <div class="product-body">
            <div class="img-div zoom-image">
              <img :src="baseImageUrl+item.fileUrl" />
            </div>
            <p>{{item.groupName}}</p>
          </div>
        </router-link>
      </el-col>
    </el-row>
  </div>
  <div class="home-index-product">
    <el-row >
      <el-col class="descrption-div"  :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <div class="descrption-img zoom-image">
          <img :src="baseImageUrl+paramsinfo.reservedField1" />
        </div>
      </el-col>
      <el-col   :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <div class="descrption-div">
          <div class="descrption-title">{{locale[language.code].home.module.name2}}</div>
          <p class="descrption-info">
            {{paramsinfo.introduction}}
          </p>
          <div class="descrption-btn">
            <router-link to="/aboutme" :underline="false">
              <el-button type="primary" size="large"><el-icon><Document /></el-icon>{{locale[language.code].home.module.learmode}}</el-button>
            </router-link>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
  <div class="home-index-product">
    <el-row >
      <el-col v-for="item in customizedsolutionList" :key="item.id"  :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
        <router-link :underline="false" :to="'/customercasedetial/'+item.id" style="text-decoration: none;">
          <div class="technology-div">
            <img class="zoom-image" :src="item.coverImage" />
            <p>{{item.title}}</p>
            <div class="info">
              {{item.summary}}
            </div>
          </div>
        </router-link>
      </el-col>
    </el-row>
  </div>
  <div class="home-index-product">
    <p class="index-title">{{locale[language.code].home.module.name3}}</p>
    <el-row>
      <el-col v-for="item in companytechnologyList" :key="item.id" :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
        <router-link :underline="false" :to="'/companytechnologydetial/'+item.id" style="text-decoration: none;">
          <div class="technology-item zoom-image">
            <img :src="item.coverImage" />
          </div>
          <div class="technology-info">
            <p class="title">{{item.title}}</p>
            <p class="info">{{item.summary}}</p>
          </div>
        </router-link>
      </el-col>
    </el-row>
  </div>
  <div class="home-index-product">
    <p class="index-title">{{locale[language.code].home.module.name4}}</p>
    <el-row>
      <el-col v-for="item in websitescreensList" :key="item" :xs="12" :sm="12" :md="12" :lg="6" :xl="6">
        <router-link :to="'/product/'+item.id" :underline="false" style="text-decoration: none;">
          <div class="product-body">
            <div class="img-div zoom-image">
              <img :src="baseImageUrl+item.smallImages" />
            </div>
            <p>{{item.name}}</p>
          </div>
        </router-link>
      </el-col>
    </el-row>
  </div>
  <div class="home-index-product">
    <p class="index-title">{{locale[language.code].home.module.name5}}</p>
    <el-row>
      <el-col v-for="item in cooperationpartnersList" :key="item.id" :xs="12" :sm="12" :md="12" :lg="4" :xl="4">
        <div class="custom-div zoom-image">
          <img :src="item.companyIcon" />
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  mainimage,
  producttype,
  cooperationpartners,
  websitescreens,
  customizedsolution,
  companytechnology
} from '@/api/Home';
import locale from "@/locale/locale";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Home',
  components: {
  },
  props:{
    paramsinfo:{
      type:Object,
      default:()=> ({})
    }
  },
  watch:{
    paramsinfo:{
      handler(val) {
        console.log(val);
      },
      deep: true
    }
  },
  data(){
    return{
      locale:locale,
      hasLoad:false,
      language:null,
      smallImageHeight:'482px',
      baseImageUrl:process.env.VUE_APP_FILE_API,
      //paramsinfo:{},
      mainImageList:[],
      productTypeList:[],
      productList:[],
      cooperationpartnersList:[],
      customizedsolutionList:[],
      websitescreensList:[],
      companytechnologyList:[],
      productGroupList:[
        {imgUrl:"../static/img/prodcut-img.jpg",name:"标准TFT液晶屏"},
        {imgUrl:"../assets/prodcut-img.jpg",name:"IPS液晶屏"},
        {imgUrl:"../assets/prodcut-img.jpg",name:"触摸显示屏"},
        {imgUrl:"../assets/prodcut-img.jpg",name:"高亮液晶屏"},
        {imgUrl:"../assets/prodcut-img.jpg",name:"宽温液晶屏"},
        {imgUrl:"../assets/prodcut-img.jpg",name:"正方形/圆形/长条形液晶屏"}
      ]
    }
  },
  created() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
    var languageStr = localStorage.getItem("website-language");

    if(!languageStr){
      var intervalIndex = setInterval(() =>{
        var languageStr = localStorage.getItem("website-language");
        if(languageStr){
          clearInterval(intervalIndex);
          this.language = JSON.parse(languageStr);
          this.initData();
        }
      },100);
    }else{
      this.language = JSON.parse(languageStr);
      this.initData();
    }
  },

  methods:{
    imgOnError(event){
      this.smallImageHeight =
          (window.innerWidth*event.target.naturalHeight/event.target.naturalWidth)+'px';
      // if(window.screen.width < 720){
      //   this.smallImageHeight = '200px';
      // }
    },
    initData(){
      mainimage(this.language.id).then(res => {
        console.log(res);
        this.mainImageList = res.data;
      });

      producttype({id:this.language.id}).then(res => {
        console.log(res);
        this.productTypeList = res.data;
      });

      cooperationpartners().then(res => {
          this.cooperationpartnersList = res.data;
      });

      customizedsolution({id:this.language.id}).then(res => {
          this.customizedsolutionList = res.data;
      });

      websitescreens({id:this.language.id}).then(res => {
          this.websitescreensList = res.data;
          for(var tempIndex in this.websitescreensList){
            this.websitescreensList[tempIndex].smallImages = this.websitescreensList[tempIndex].smallImages.split(",")[0];
          }
      });

      customizedsolution({id:this.language.id}).then(res => {
        this.customizedsolutionList = res.data;
      });

      companytechnology({id:this.language.id}).then(res => {
        this.companytechnologyList = res.data;
      });

      // paramsinfo(this.language.id).then(res => {
      //   this.paramsinfo = res.data[0];
      // });
    }
  }
}
</script>

<style>

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.bottom-fooler-div{
  background-color: #202123;
  position: relative;
  min-height:60px;
}

.home-index-product{
  padding:45px 20px;
}

.home-index-product:nth-child(odd){
  background-color: #F5f5f5;
}

.home-index-product .index-title{
  font-weight: bold;
  font-size: 2rem;
  color:#303133;
}
.home-index-product .product-body{
  padding:4px 6px;
  text-align: justify;
}
.product-body p{
  text-align: center;
}
.home-index-product .product-body  .img-div{
  border:1px solid #E4E7ED;
  padding:8px 12px;
  border-radius: 6px;
}
.home-index-product .product-body .img-div img{
  width:100%;
}

.descrption-div{
  height:300px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
}

.descrption-img{
  height:300px;
}

.descrption-img img{
  height: 100%;
  max-width: 100%;

}

.descrption-div .descrption-title{
  font-weight: bold;
  font-size: 2rem;
  color:#303133;
}

.descrption-div .descrption-info{
  text-align: left;
  text-indent:2rem;
  word-spacing: 4px;
  color:#363636;
  text-align: justify;
}

.technology-div{
  margin:40px 15px;
  color:#303133;
}

.technology-div img{
  width:100%;
}

.technology-div p{
  font-weight: bold;
}
.technology-div .info{
  text-align: left;
  text-indent:2rem;
  color:#909399;
  font-size: 14px;
  text-align: justify;
}
.technology-item{
  margin:10px 18px;
}
.technology-item img{
  width: 100%;
  border:1px solid #F5f5f5;
  box-shadow: 0px 0px 15px 0px #F1F1F1;
}

.technology-info{
  margin:10px 18px;
}

.technology-info .title{
  font-weight: bold;
  text-align:left;
}

.technology-info .info{
  font-size: 14px;
  text-align: justify;
}


.carousel-div{
  width:100%;
}

.carousel-div .carousel-img{
  height:100%;
}

.custom-div{
  margin:10px 0px;
}

.bottom-page{
  padding:35px 20px;
  background-color: #505050;
}

.bottom-page .page-col{
  text-align: left;
  color:#eee;
}

.bottom-page .page-col .title{
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 10px;

}

.bottom-page .page-col .content{
  font-size: 14px;
  color:#eee;
  display: flex;
  flex-flow: column nowrap;
}

.bottom-page .page-col .content a{
  color:#eee;
  text-decoration: none;
  margin: 4px;
}

@media (min-width: 720px) {

  .el-carousel__arrow--left{
    left:106px!important;
  }

  .el-carousel__arrow--right {
    right: 106px!important;
  }
}

.zoom-image {
  transition: transform 0.5s ease; /* 平滑过渡效果 */
}

.zoom-image:hover {
  transform: scale(1.06); /* 放大10% */
}




</style>